// src/components/LanguageRedirector.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSiteLanguage } from '../hooks/useSiteLanguage';

/**
 * A component that handles redirection for routes that are accessed
 * without a language prefix. It uses the useSiteLanguage hook to
 * determine the correct language and redirects accordingly.
 */
const LanguageRedirector = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = useSiteLanguage(); // This hook contains the redirection logic

  useEffect(() => {
    navigate(`/${lang}${location.pathname}${location.search}`, { replace: true });
  }, [lang, location, navigate]);

  return null; // This component does not render anything
};

export default LanguageRedirector;
